import usePublicEnvVars from '@/hooks/usePublicEnvVars';
import { COUNTRY, CURRENCY } from '@/types/api/common';
import { getCountry, getCurrency } from '@/utils/country';

export const useCountryAndCurrency = () => {
  const { brand } = usePublicEnvVars();

  const currency = brand ? getCurrency(brand) : CURRENCY.NOK;
  const country = brand ? getCountry(brand) : COUNTRY.NORWAY;

  return { currency, country, brand };
};
